import React from 'react'

const Expand = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/expand',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g
      fill='none'
      fillRule='evenodd'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    >
      <path d='M3.438 10.438v6.124h6.124' stroke={primaryColor} />
      <path stroke={primaryColor} d='M6.5 4.5h9v9h-9z' />
    </g>
  </svg>
)

export default Expand
